import { Button } from "../Button"
import { Input, Label } from "../Form"
import "./styles.scss"

export const LoginLogo = ({logo}) => {

  return (
    <div className="login-content-logo">
      <div className="login-logo" style={{backgroundImage: `url(${logo})`,}}></div>
    </div>
  )
}

export const LoginForm = ({ register, handleCantAccess, handleSubmit, handleIsRecovery, isRecovery, logo }) => {

  return (
    <div className="login-content-form">
      <div className="login-form">
        <div className="login-form--top">
          <LoginLogo logo={logo} />
          <h2 className="login-form-title">Seja bem-vindo(a)!</h2>
          <span className="login-form-description">
            {!isRecovery ? "Informe o seu email e sua senha cadastrada" : "Vamos recuperar sua senha ?"}
          </span>
        </div>
        <div className="login-form--bottom">
          <Label color={"gray"} label="Email" col={12} />
          <Input
            placeholder="Digite o seu email"
            register={register("username")}
            autoComplete={"off"}
          />
          {!isRecovery && <><Label color={"gray"} label="Senha" col={12} />
          <Input
            type={"password"}
            name="password"
            placeholder="Digite a sua senha"
            register={register("password")}
            autoComplete={"off"}
          /></>}
          <div className="login-form-buttons">
            <Button
              label="Não consigo acessar"
              variant="ghost"
              handleClick={handleCantAccess}
            />
            <Button
              type="submit"
              label={!isRecovery ? "Entrar": "Recuperar Senha"}
              pressKey={handleSubmit}
              handleClick={handleSubmit}
              className={"button-login"}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
